define('views/pages/dashboard/balance',['require','views/base/view','views/pages/dashboard/panel','text!templates/pages/dashboard/balance.ejs'],function(require) {
    'use strict';

    var View = require('views/base/view'),
        DashboardPanel = require('views/pages/dashboard/panel'),
        template = require('text!templates/pages/dashboard/balance.ejs');

    var BalanceView = View.extend({
        autoRender: true,
        template: template
    });

    var BalancePanelView = DashboardPanel.extend({
        autoRender: true,
        listen: {
            'change:value model': 'render'
        },
        render: function() {
            DashboardPanel.prototype.render.apply(this, arguments);

            this.subview('content', new BalanceView({ collection: this.model.items, model: this.model, container: this.$('.panel-content') }));
        }
    });

    return BalancePanelView;
});

